import {
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'fz-info',
  standalone: true,
  imports: [MatTooltip],
  templateUrl: './info-icon.html',
  styleUrls: ['./info-icon.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class InfoIcon {
  info = input<string>();
}
